import React from 'react';
import useWindowScroll from '../../services/hooks/useWindowScroll';
import ReservationPanel from '../../components/reservation-panel';
import MobilePhotoGallery from './mobile-photo-gallery';
import SingleViewPhoto from './single-view-photo';
import SvgChevronLeft from 'src/assets/svg/SvgChevronLeft.svg';

const SPOT_MIN_REQ_PHOTOS = 10;

const RenderMobilePhotoGallery = ({
    spot,
    singleViewPhoto,
    singlePhotoHandler,
    setMobilePhotoCount,
    setMobilePhotoGallery,
    setSingleViewPhoto,
    mobilePhotoCount,
    waitInfo,
    handleBook,
    handleSwipeMobile,
    publicPark,
}) => {
    const scrollTop = useWindowScroll();
    const myPhotos = publicPark ? spot.allPhotos?.map((p, i) => ({ id: i + 1, imageAws: p })) : spot.spotPhotos;
    const canShowRequest = !publicPark && myPhotos && myPhotos.length < SPOT_MIN_REQ_PHOTOS;

    return (
        <div className="mobile-photo-gallery" style={singleViewPhoto !== null ? { height: '100dvh', overflowY: 'auto' } : {}}>
            <div className="gallery-header">
                <span
                    className="back-ico"
                    onClick={() => {
                        if (singleViewPhoto === null) {
                            setMobilePhotoCount(1);
                            setMobilePhotoGallery(false);
                            scrollTop();
                        } else {
                            setSingleViewPhoto(null);
                        }
                    }}
                >
                    <SvgChevronLeft height={14} />
                </span>
                <p className="snif-s1 snif-medium mb-0">Spot pictures</p>
            </div>
            {singleViewPhoto === null && myPhotos && (
                <MobilePhotoGallery
                    singlePhotoHandler={singlePhotoHandler}
                    mobilePhotoCount={mobilePhotoCount}
                    photos={myPhotos}
                    spotId={spot.id}
                    hostId={spot.host?.id}
                    title={spot.title}
                    state={spot.state}
                    city={spot.city}
                    canShowRequest={canShowRequest}
                />
            )}
            {singleViewPhoto !== null && (
                <SingleViewPhoto hostId={spot.host?.id} {...{ spot, handleSwipeMobile, mobilePhotoCount, singleViewPhoto }} />
            )}
            {!publicPark && (
                <ReservationPanel
                    commentsNmb={spot.reviewsCount}
                    title={spot.title}
                    rating={spot.rating}
                    price={spot.price}
                    wait={waitInfo}
                    id={spot.id}
                    live={spot.live || spot.host?.id > 0}
                    handleBook={handleBook}
                />
            )}
        </div>
    );
};

export default RenderMobilePhotoGallery;
